import React from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";


function Comment() {
  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={8} className="rgc-request p-4 rgc-profile ">
            <div className="d-flex rgc-title">
              <div className="rgc-title-point"></div>
              <h4>ثبت <span>نظرات و پیشنهادات</span></h4>
            </div>
            <Row className="justify-content-center">

              <Col xs={6} className="mb-3">
                <Form.Group>
                  <Form.Label>ارجاع به</Form.Label>
                  <Form.Select 
                   className="rgc-select"
                  >
                    <option>پیمانکار</option>
                    <option>سازمان</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col xs={12}>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                  <Form.Label>متن پیشنهادی شکایت </Form.Label>
                  <Form.Control as="textarea" rows={3} />
                </Form.Group>
              </Col>


              <Col xs={12} className="text-center">
                <Button className="rgc-orderreg-btn rgc-order-btn-sub" >
                  ارسال
                </Button>
              </Col>
              
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Comment;
